export default [
  {path:'modifyPassword',meta: {title: '修改密码'},component: resolve => { require(['../pages/ModifyPassword.vue'], resolve) }},
  {path:'system',meta: {title: '系统管理-主页'},component: resolve => { require(['../pages/SystemManager.vue'], resolve) }},
  {path:'homeTransfer',meta: {title: '系统管理-导航'},component: resolve => { require(['../pages/HomeTransfer.vue'], resolve) },
    children:[
      {path:'menuTab',meta: {title: '菜单Tab'} ,component: resolve => { require(['@/components-manager/sysmenus/MenuTab.vue'], resolve) },
        children:[
          {path:'menuDetail',meta: {title: '菜单内容'} ,component: resolve => { require(['@/components-manager/sysmenus/menuDetail.vue'], resolve) }},
        ]
      },
      {path:'roleManager',meta: {title: '角色管理'} ,component: resolve => { require(['@/components-manager/sysrole/RoleManager.vue'], resolve) },
        children:[
          {path:'roleTab',meta: {title: '角色Tab'} ,component: resolve => { require(['@/components-manager/sysrole/RoleTab.vue'], resolve) },
            children:[
              {path:'roleMenu',meta: {title: '角色菜单权限'} ,component: resolve => { require(['@/components-manager/sysrole/RoleMenu.vue'], resolve) }},
              {path:'roleUser',meta: {title: '拥有该角色的用户'} ,component: resolve => { require(['@/components-manager/sysrole/RoleUser.vue'], resolve) }},
              {path:'mobileMenu',meta: {title: '应用权限'} ,component: resolve => { require(['@/components-manager/sysrole/mobileMenuList.vue'], resolve) }}
            ]
          },
        ]
      },
      {path:'dataParams',meta: {title: '参数管理'} ,component: resolve => { require(['@/components-manager/sysDataParam/DataParams.vue'], resolve) }},
      {path: 'baseSetTab',meta: {title: '校区'},component: resolve => { require(['../components-manager/baseset/BaseSetTab.vue'], resolve) },
        children:[
          {path: 'topUnitSet',meta: {title: '校区'},component: resolve => { require(['../components-manager/baseset/TopUnitSet.vue'], resolve) }},
          {path: 'sysJglx',meta: {title: '校区'},component: resolve => { require(['../components-manager/baseset/SysJglx.vue'], resolve) }},
          {path: 'xxLevel',meta: {title: '级别'},component: resolve => { require(['../components-manager/baseset/XxLevel.vue'], resolve) }},
          {path: 'xxNjqy',meta: {title: '年级'},component: resolve => { require(['../components-manager/baseset/XxNjqy.vue'], resolve) }},
          {path: 'xxYear',meta: {title: '学年'},component: resolve => { require(['../components-manager/baseset/xxYear.vue'], resolve) }},
          {path: 'xxXnxq1',meta: {title: '学年学期'},component: resolve => { require(['../components-manager/baseset/XxXnxq.vue'], resolve) }},
          {path: 'unitTree',meta: {title: '班级树'},component: resolve => { require(['../components-manager/baseset/unitTree.vue'], resolve) },
            children:[
              {path: 'xxBjxx',meta: {title: '班级'},component: resolve => { require(['../components-manager/baseset/XxBjxx.vue'], resolve) }},
            ]
          },
          {path: 'xsxxTabs',meta: {title: '学生'},component: resolve => { require(['../components-manager/xsxx/XsxxTabs.vue'], resolve) },
            children:[
              {path: 'xsxxManager',meta: {title: '学生管理'},component: resolve => { require(['../components-manager/xsxx/XsxxManager.vue'], resolve) }},
              {path: 'xsxxTb',meta: {title: '学生调班'},component: resolve => { require(['../components-manager/xsxx/XsxxTb.vue'], resolve) }},
              {path: 'xsxxYdManager',meta: {title: '学生异动'},component: resolve => { require(['../components-manager/xsxx/XsxxYdManager.vue'], resolve) }},
            ]
          },
          {path: 'sysUnitsManager', meta: {title: '机构管理'}, component: resolve => { require(['@/components-manager/sysunits/SysUnitsManager.vue'], resolve) }},
          {path: 'sysUsersManager', meta: {title: '用户管理'}, component: resolve => { require(['@/components-manager/sysusers/SysUsersManager.vue'], resolve) }},
          {path: 'zyTabs',meta: {title: '班级树'},component: resolve => { require(['../components-manager/zy/ZyTabs.vue'], resolve) },
            children:[
              {path: 'zyManagers',meta: {title: '专业类别'},component: resolve => { require(['../components-manager/zy/ZyManagers.vue'], resolve) }},
              {path: 'zyfxManagers',meta: {title: '专业方向'},component: resolve => { require(['../components-manager/zy/ZyfxManagers.vue'], resolve) }},
              {path: 'zyTypeManagers',meta: {title: '专业方向'},component: resolve => { require(['../components-manager/zy/ZyTypeManagers.vue'], resolve) }},
            ]
          },
          {path: 'ynEduManage', meta: {title: '依能平台基础信息同步'}, component: resolve => { require(['@/components-manager/baseset/YnEduManage.vue'], resolve) }},
        ]
      },
      {path:'pcAttributeSet',meta: {title: '系统参数设置'} ,component: resolve => { require(['@/components-manager/system/PcAttributeSet.vue'], resolve) }},
      
      {path: 'sysLogsTab',meta: {title: '系统日志'}, component: resolve => { require(['../components-manager/syslogs/SysLogsTab.vue'], resolve) },
        children:[
          {path: 'sysLogs',meta: {title: '系统日志'}, component: resolve => { require(['../components-manager/syslogs/SysLogs.vue'], resolve) }},
        ]
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/system.js